/**
 * @generated SignedSource<<9110e495760b09c08972156fb45634ee>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
export type TodoStatus = "DONE" | "PENDING";
import { FragmentRefs } from "relay-runtime";
export type TodoDetailSubTodos_todo$data = {
  readonly subTodos: ReadonlyArray<{
    readonly id: string;
    readonly status: TodoStatus;
    readonly " $fragmentSpreads": FragmentRefs<"TVTodoSubListItem_todo">;
  }> | null;
  readonly " $fragmentSpreads": FragmentRefs<"TodoEditNewMainPreventDefault_todo">;
  readonly " $fragmentType": "TodoDetailSubTodos_todo";
};
export type TodoDetailSubTodos_todo$key = {
  readonly " $data"?: TodoDetailSubTodos_todo$data;
  readonly " $fragmentSpreads": FragmentRefs<"TodoDetailSubTodos_todo">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "TodoDetailSubTodos_todo",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "Todo",
      "kind": "LinkedField",
      "name": "subTodos",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "id",
          "storageKey": null
        },
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "TVTodoSubListItem_todo"
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "status",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "TodoEditNewMainPreventDefault_todo"
    }
  ],
  "type": "Todo",
  "abstractKey": null
};

(node as any).hash = "c62c60e8eaddefce3925e162ae3119ed";

export default node;
